import { HttpErrorResponse } from '@angular/common/http';
import { ErrorResponseHandler } from './error-response-handler';
import { Injectable } from '@angular/core';

@Injectable()
export class DefaultErrorResponseHandler implements ErrorResponseHandler {
  priority = -100;

  canHandle(_error: HttpErrorResponse): boolean {
    return true;
  }

  buildErrorMessages(error: HttpErrorResponse): string[] {
    switch (error.status) {
      case 0:
        return ['Network error. Please try again.'];
      case 400:
        return ['Validation issue.'];
      case 401:
        return ['Session expired. Please sign in again.'];
      case 403:
        return ['You don’t have permission to do that.'];
      case 409:
        return ['Conflict detected. Please resolve and try again.'];
      default:
        return [this.defaultErrorMessage()];
    }
  }

  defaultErrorMessage(): string {
    return 'Something went wrong. Please try again.';
  }
}
